import {View} from "./View"
export const InvoiceTemplateLink =  ()=> {
    return(
        <View />
    )
}